import React from "react"
import MuiSwitch from "@mui/material/Switch"

/**
 * Taken with adjustments from: https://github.com/stackworx/formik-mui/blob/main/packages/formik-mui/src/Checkbox.tsx
 */
function fieldToSwitch({
  disabled,
  field: { onBlur: fieldOnBlur },
  form: { isSubmitting, setFieldValue, setFieldTouched },
  onChange,
  form,
  field,
  type,
  onBlur,
  ...props
}) {
  const { onChange: _onChange, ...fieldRest } = field

  return {
    disabled: disabled ?? isSubmitting,
    checked: field.value,
    onChange: function handleChange(event, value, reason) {
      if (onChange) {
        onChange(event, value, reason)
      }
      setFieldValue(field.name, value)
      setFieldTouched(field.name)
    },
    onBlur:
      onBlur ??
      function onBlur(e) {
        fieldOnBlur(e ?? field.name)
      },
    ...fieldRest,
    ...props
  }
}

export function Switch(props) {
  return <MuiSwitch {...fieldToSwitch(props)} />
}

Switch.displayName = "FormikMaterialUISwitch"
